import axios from "axios";

export default {
    fetchExam(id) {
        return axios.get('exams/' + id)
            .then(response => {
                return response.data
            })
    },

    fetchExams() {
        return axios.get('exams')
            .then(response => {
                return response.data
            })
    },

}
